import React, {useState} from "react";
import ProfilePost from "./Profile_posts__post/ProfilePost";
import ProfileField from "./Profile_posts__Field/ProfileField";




const ProfilePosts = (props) => {
    let [comment, changeComment] = useState(0);

    const onSubmit = (text) => {
        props.addPost(text.postMessage, props.myPhotos, props.name) /*заглушка фото*/
    };

    return (
        <div>
            <div className="profile__posts">
                {/*{posts}*/}
                <ProfilePost img={props.posts[comment].img}
                             name={props.posts[comment].name}
                             textPost={props.posts[comment].textPost}
                             changeCommentRight={() => changeComment(comment + 1)}
                             changeCommentLeft={() => changeComment(comment - 1)}
                             numberComments={comment}
                             numberCommentsInArray={props.posts.length}
                />
            </div>
            <ProfileField myPhotos={props.myPhotos} onSubmit={onSubmit}/>
        </div>
    )
};


export default ProfilePosts